import { render, staticRenderFns } from "./OfferIdTooltip.vue?vue&type=template&id=8abcf71a&scoped=true&"
import script from "./OfferIdTooltip.vue?vue&type=script&lang=js&"
export * from "./OfferIdTooltip.vue?vue&type=script&lang=js&"
import style0 from "./OfferIdTooltip.vue?vue&type=style&index=0&id=8abcf71a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abcf71a",
  null
  
)

export default component.exports